export default {
  'pages.orderNo.table.title': '订单编号配置',
  'pages.orderNo.subTitle': '管理不同业务类型的编号前缀配置',
  'pages.orderNo.table.columns.type': '类型',
  'pages.orderNo.table.columns.prefix': '前缀',
  'pages.orderNo.table.columns.description': '描述',
  'pages.orderNo.table.columns.operations': '操作',
  'pages.orderNo.actions.edit': '编辑',
  'pages.orderNo.message.loadFailed': '加载失败',
  'pages.orderNo.message.missingRecord': '缺少记录信息',
  'pages.orderNo.message.updateSuccess': '更新成功',
  'pages.orderNo.message.updateFailed': '更新失败',
  'pages.orderNo.form.editTitle': '编辑订单编号配置',
  'pages.orderNo.form.typeLabel': '类型',
  'pages.orderNo.form.prefixLabel': '前缀',
  'pages.orderNo.form.prefixRequired': '请输入前缀',
  'pages.orderNo.form.prefixMaxLength': '前缀长度不能超过50个字符',
  'pages.orderNo.form.prefixPlaceholder': '请输入前缀',
  'pages.orderNo.form.descriptionLabel': '描述',
};
